import React, { useEffect, useRef, useState } from "react";

function AudioPlayer({
    src,
    loader = null,
    autoPlay = false,
    className = "",
    onEnded,
}) {
    const audioRef = useRef(null);

    const [isReady, setIsReady] = useState(false);
    const [hasError, setHasError] = useState(false);

    /*
     * A new url means a new download - go back to the loading state.
     */
    useEffect(() => {
        setIsReady(false);
        setHasError(false);
    }, [src]);

    /*
     * canplay already implies HAVE_FUTURE_DATA, but re-check so a stale event
     * from a previous src cannot reveal an unplayable element.
     */
    const markReady = () => {
        const audio = audioRef.current;

        if (audio && audio.readyState >= HTMLMediaElement.HAVE_FUTURE_DATA) {
            setIsReady(true);
            setHasError(false);
        }
    };

    const handleError = () => {
        setIsReady(false);
        setHasError(true);
    };

    if (!src) {
        return loader;
    }

    return (
        <>
            {!isReady && !hasError && loader}

            {hasError && (
                <span className="audio-error">Unable to load audio.</span>
            )}

            <audio
                ref={audioRef}
                controls
                preload="auto"
                autoPlay={autoPlay}
                src={src}
                className={className}
                style={{ display: isReady ? "block" : "none" }}
                onLoadStart={() => {
                    setIsReady(false);
                    setHasError(false);
                }}
                onCanPlay={markReady}
                onProgress={markReady}
                onError={handleError}
                onEnded={onEnded}
            />
        </>
    );
}

export default AudioPlayer;
